import TemplateView from '../../../TemplateView'

export default class SelectAllButton extends TemplateView {
    constructor({
        onSelectAllCallback = (isAllSelected) => {},
    }) {
        super()

        this.onSelectAllCallback = onSelectAllCallback

        this.state = {
            isAllSelected: false,
        }

        this.onStatePropertyChanged('isAllSelected', this._handleAllSelection)
    }

    templateHtml() {
        return "<div class='selectAllButtons'>" +
               "    <div class='selectAllButton'>" +
               "        <div class='selectAllButtonImage'></div>" +
               "        <div class='selectAllButtonLabel'><%=selectAllText%></div>" +
               "    </div>" +
               "    <div class='deselectAllButton'>" +
               "        <div class='deselectAllButtonImage'></div>" +
               "        <div class='deselectAllButtonLabel'><%=deselectAllText%></div>" +
               "    </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            selectAllText: 'task.list.kanban.filters_panel.select_all',
            deselectAllText: 'task.list.kanban.filters_panel.deselect_all',
        }
    }

    afterRender() {
        this.$selectAllButton = this.find(".selectAllButton")
        this.$selectAllButton.click(() => this.onSelectAllCallback(true))
        this.$deselectAllButton = this.find(".deselectAllButton")
        this.$deselectAllButton.click(() => this.onSelectAllCallback(false))
        this.renderInitialState()
    }

    _handleAllSelection = (isAllSelected) => {
        this.$selectAllButton.toggle(!isAllSelected)
        this.$deselectAllButton.toggle(isAllSelected)
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/SelectAllButton.js